import { render, staticRenderFns } from "./RegisterMovement.vue?vue&type=template&id=604e23b6&scoped=true&"
import script from "./RegisterMovement.vue?vue&type=script&lang=ts&"
export * from "./RegisterMovement.vue?vue&type=script&lang=ts&"
import style0 from "./RegisterMovement.vue?vue&type=style&index=0&id=604e23b6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "604e23b6",
  null
  
)

export default component.exports